import React, { useState } from 'react';
import Modal from '../../components/Classroom/Modal';
import InputField from '../../components/Login/InputField';
import '../../css/Classroom.css';

const CreateOrJoinClass = ({ onCreate, onJoin }) => {
  const [showCreateModal, setShowCreateModal] = useState(false);
  const [showJoinModal, setShowJoinModal] = useState(false);
  const [className, setClassName] = useState('');
  const [classCode, setClassCode] = useState('');

  const handleCreate = () => {
    if (className.trim()) {
      onCreate(className);
      setShowCreateModal(false);
    }
  };

  const handleJoin = () => {
    if (classCode.trim()) {
      onJoin(classCode);
      setShowJoinModal(false);
    }
  };

  return (
    <div className="create-join-container">
      <div className="house-icon">
        {/* Placeholder for house image */}
      </div>
      <div className="class-actions">
        <button className="create" onClick={() => setShowCreateModal(true)}>Create class</button>
        <button className="join" onClick={() => setShowJoinModal(true)}>Join Class</button>
      </div>

      {showCreateModal && (
        <Modal title="Create class" onClose={() => setShowCreateModal(false)}>
          <InputField
            type="text"
            placeholder="classname*"
            value={className}
            onChange={(e) => setClassName(e.target.value)}
          />
          <button className="modal-enter" onClick={handleCreate}>Enter</button>
        </Modal>
      )}

      {showJoinModal && (
        <Modal title="Join class" onClose={() => setShowJoinModal(false)}>
          <InputField
            type="text"
            placeholder="classroom name*"
            value={className}
            onChange={(e) => setClassName(e.target.value)}
          />
          <InputField
            type="text"
            placeholder="class code*"
            value={classCode}
            onChange={(e) => setClassCode(e.target.value)}
          />
          <button className="modal-enter" onClick={handleJoin}>Enter</button>
        </Modal>
      )}
    </div>
  );
};

export default CreateOrJoinClass;